<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold py-3">درخواست های دیجی پی فاکتور {{ id }}</h5>
                <div style="flex: 1"></div>
                <Back url="/admin/shop/orders" />
            </div>
            <div id="print" class="p-4">
                <template v-if="reports && reports.length">
                    <b-table id="main-table" bordered striped :fields="fields" :items="reports" responsive="sm">
                        <template v-slot:cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(amount)="data">
                            {{ data.item.amount | price }}
                        </template>
                        <template v-slot:cell(status)="data">
                            <span :class="['badge', statuses[data.item.status].color]">
                                {{ statuses[data.item.status].label }}
                            </span>
                        </template>

                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate }}
                        </template>
                    </b-table>
                    <div v-if="this.reports[0].provider_id"
                        class="d-flex flex-column justify-content-center align-items-center mt-3">
                        <button class="inquiry-btn" @click="inquiry" :disabled="disabled">
                            استعلام خرید زنده
                        </button>

                        <p v-if="returnedLabelStatus" class="mt-3">
                            نتیجه استعلام :
                            <span class="font-weight-bold mr-1">{{ returnedLabelStatus }}.</span>
                        </p>
                    </div>
                </template>
                <div class="d-flex justify-content-center" style="background: #ff0000c2;" v-else>
                    <p class="font-weight-bold text-white mt-1"> درخواستی برای این فاکتور ثبت نشده. </p>
                </div>


                <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
            </div>
        </div>
    </main>
</template>

<script>
import { BTooltip, BTable, BTd, VBToggle, VBTooltip } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Back from "@@/core/components/shared/Back/Back";
import mixins from '@@/core/mixins/mixins'

export default {
    name: "DigipayCashierReport",
    mixins: [mixins],
    components: {
        BTable,
        Back,

        BTooltip,
        BTd,
    },
    directives: {
        'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    configProvider,
    data() {
        return {
            disabled: true,
            id: this.$route.params.id,
            fields: [
                {
                    key: "index",
                    label: "ردیف",
                },
                {
                    key: "id",
                    label: "شناسه‌ی درخواست",
                },
                {
                    key: "barcode",
                    label: "بارکد",
                },
                {
                    key: "amount",
                    label: "مبلغ(تومان)",
                },
                {
                    key: "status",
                    label: "وضعیت",
                },
                {
                    key: "created_at",
                    label: "تاریخ ثبت",
                },
                {
                    key: "provider_id",
                    label: "پروایدر ایدی",
                },
            ],
            page: 1,
            returnedStatus: "",
            returnedLabelStatus: "",
            reports: [],
            inquiryStatuses: {
                WAITING_FOR_CONFIRMATION: "خرید در انتظار تایید مشتری است",
                PAID: "خرید انجام شده اما نهایی نشده است",
                CANCELED: "خرید انصراف داده شده است",
                COMPLETED: "خرید نهایی شده است",
                FAILED: "خرید ناموفق است",
                REVERSED: "خرید ریورس شده است",
                PROGRESS_IN_REVERSE: "ریورس در حال انجام است",
                REJECTED: "خرید رد شده است",
                PROCESSING: "خرید در حال پردازش است",
                EXPIRED: "خرید در زمان لازم توسط کاربر تایید نشده است",
            },
            statuses: {
                pending_for_confirmation: {
                    label: "خرید در انتظار تایید مشتری",
                    color: "badge-warning"
                },
                paid: {
                    label: "خرید انجام شده اما نهایی نشده",
                    color: "badge-secondary"
                },
                canceled: {
                    label: "خرید انصراف داده شده",
                    color: "badge-danger"
                },
                completed: {
                    label: "خرید نهایی شده",
                    color: "badge-success"
                },
                reversed: {
                    label: "خرید ریورس شده",
                    color: "badge-info"
                }
            }

        };
    },
    created() {
        this.loadData();
    },
    methods: {
        async inquiry() {
            try {
                this.disabled = true;
                const response = await this.$axios.get("admin/digify-cashier-inquiry",
                    {
                        params: {
                            provider_id: this.reports.length ? this.reports[0].provider_id : '',
                        }
                    }
                );
                this.returnedStatus = response.data.purchaseStatus;
                this.returnedLabelStatus = this.inquiryStatuses[response.data.purchaseStatus];
                this.isBuy = true;
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
            }
        },
        async loadData() {
            this.disabled = false;
            const response = await this.$axios.get("admin/mini_orders/" + this.id);
            this.reports = response.data.data.digipay_cashierRequests;
            console.log(this.reports, 'this.reports');
        },
    },
};
</script>
<style src="@@/core/pages/physicalShop/digipay/digipayStyle.css"></style>